import Vue from 'vue'
let $ = require('jQuery')

Vue.directive('iptFocus', {
  inserted: function (el, binding) {
    let $el = $(el)
    let $parent = $el.parent()

    setTimeout(() => {
      if ($el.val()) {
        $parent.addClass('focus')
      }

      if (binding.value && binding.value.focus) {
        $parent.addClass('focus')
        $el.focus()
      }
    })

    if ($el.hasClass('el-input')) {
      $el = $el.find('input')
      $parent = $el.parent().parent()
    }
    $el.focus(function () {
      $parent.addClass('focus')
    })
    $el.blur(function () {
      if (!$el.val()) {
        $parent.removeClass('focus')
      }
    })
  },
  update: function (el, binding) {
    let $el = $(el)
    let $parent = $el.parent()
    if ($el.val()) {
      $parent.addClass('focus')
    }
    if (binding.value && binding.value.focus) {
      $parent.addClass('focus')
      $el.focus()
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/IptFocus.js